import { BusinessPartner } from './businessPartner';
import { OutletPeer } from './outletPeer';
import { PartsCatalogSettings } from './partsCatalogSettings';
export class User {
    constructor() {
        this.id = '';
        this.name = '';
        this.countryCodeIso = '';
        this.locale = 'en-US';
        this.mileageUnit = 'km';
        this.volumeUnit = 'l';
        this.temperatureUnit = 'C';
        this.timezoneOffset = 0;
        this.partsCatalogSettings = null;
        this.defaultApp = '';
        this.selectedVehicleType = "UNKNOWN";
        this.roles = [];
        this.context = '';
        this.email = '';
        this.phone = '';
        this.outletPeers = [];
    }
    getId() {
        return this.id;
    }
    setId(id) {
        this.id = id;
    }
    getName() {
        return this.name;
    }
    setName(name) {
        this.name = name;
    }
    getCountryCodeIso() {
        return this.countryCodeIso;
    }
    setCountryCodeIso(countryCodeIso) {
        this.countryCodeIso = countryCodeIso;
    }
    getLocale() {
        return this.locale;
    }
    setLocale(locale) {
        this.locale = locale;
    }
    getMileageUnit() {
        return this.mileageUnit;
    }
    setMileageUnit(mileageUnit) {
        this.mileageUnit = mileageUnit;
    }
    getVolumeUnit() {
        return this.volumeUnit;
    }
    setVolumeUnit(volumeUnit) {
        this.volumeUnit = volumeUnit;
    }
    getTemperatureUnit() {
        return this.temperatureUnit;
    }
    setTemperatureUnit(temperatureUnit) {
        this.temperatureUnit = temperatureUnit;
    }
    getTimezoneOffset() {
        return this.timezoneOffset;
    }
    setTimezoneOffset(timezoneOffset) {
        this.timezoneOffset = timezoneOffset;
    }
    getPartsCatalogSettings() {
        return this.partsCatalogSettings;
    }
    setPartsCatalogSettings(partsCatalogSettings) {
        this.partsCatalogSettings = partsCatalogSettings;
    }
    getDefaultApp() {
        return this.defaultApp;
    }
    setDefaultApp(defaultApp) {
        this.defaultApp = defaultApp;
    }
    getSelectedVehicleType() {
        return this.selectedVehicleType;
    }
    setSelectedVehicleType(selectedVehicleType) {
        this.selectedVehicleType = selectedVehicleType;
    }
    getRoles() {
        return this.roles;
    }
    setRoles(roles) {
        this.roles = roles;
    }
    getContext() {
        return this.context;
    }
    setContext(context) {
        this.context = context;
    }
    getEmail() {
        return this.email;
    }
    setEmail(email) {
        this.email = email;
    }
    getPhone() {
        return this.phone;
    }
    setPhone(phone) {
        this.phone = phone;
    }
    getBusinessPartner() {
        return this.businessPartner;
    }
    setBusinessPartner(businessPartner) {
        this.businessPartner = businessPartner;
    }
    getBusinessPartners() {
        return this.businessPartners;
    }
    setBusinessPartners(businessPartners) {
        this.businessPartners = businessPartners;
    }
    getSelectedBrands() {
        return this.selectedBrands;
    }
    setSelectedBrands(selectedBrands) {
        this.selectedBrands = selectedBrands;
    }
    getSelectedCountry() {
        return this.selectedCountry;
    }
    setSelectedCountry(selectedCountry) {
        this.selectedCountry = selectedCountry;
    }
    getKeyReaderId() {
        return this.keyReaderId;
    }
    setKeyReaderId(keyReaderId) {
        this.keyReaderId = keyReaderId;
    }
    getDmsUsername() {
        return this.dmsUsername;
    }
    setDmsUsername(dmsUsername) {
        this.dmsUsername = dmsUsername;
    }
    getDmsPassword() {
        return this.dmsPassword;
    }
    setDmsPassword(dmsPassword) {
        this.dmsPassword = dmsPassword;
    }
    getDmsServiceAdvisorId() {
        return this.dmsServiceAdvisorId;
    }
    setDmsServiceAdvisorId(dmsServiceAdvisorId) {
        this.dmsServiceAdvisorId = dmsServiceAdvisorId;
    }
    getB2XCountryCode() {
        return this.getContext() === 'B2E' ? this.getSelectedCountry() : this.getCountryCodeIso();
    }
    getOutletPeers() {
        return this.outletPeers;
    }
    setOutletPeers(outletPeers) {
        this.outletPeers = outletPeers;
    }
}
User.constructFromPlainObject = (plain) => {
    let typed = new User();
    typed = Object.assign(typed, plain);
    if (plain.partsCatalogSettings) {
        typed.partsCatalogSettings = PartsCatalogSettings.constructFromPlainObject(plain.partsCatalogSettings);
    }
    if (plain.businessPartner) {
        typed.businessPartner = BusinessPartner.constructFromPlainObject(plain.businessPartner);
    }
    if (plain.businessPartners) {
        typed.businessPartners = BusinessPartner.constructFromPlainObjectList(plain.businessPartners);
    }
    if (plain.outletPeers) {
        typed.outletPeers = OutletPeer.constructFromPlainObjectList(plain.outletPeers);
    }
    return typed;
};
//# sourceMappingURL=user.js.map